export default __webpack_public_path__ + "static/mini-black-back-963efe5f181f1aa31012577060f2883c.png";